<div class="box-tappe mb-3" *ngIf="tappe">
	<strong>{{ 'PAGES.TRIP.LBL-TAPPE' | translate }}</strong>&nbsp;
	<ng-container *ngFor="let tappa of tappe; last as isLast">
		<span class="luogo">{{ tappa.luogo }}</span> <span class="tappe-divider" *ngIf="!isLast"> &#8674; </span>
	</ng-container>
</div>
